// @flow

export type SignUpIdentificationActionType = {|
  type: 'SIGNUP_SET_SELFIE_IDENTIFICATION',
  payload: {|
    identification: IdentificationType,
  |},
|};

export function setSelfieIdentification(identification: IdentificationType): SignUpIdentificationActionType {
  return {
    type: 'SIGNUP_SET_SELFIE_IDENTIFICATION',
    payload: {
      identification,
    },
  };
}

export type IdentificationType = {|
  contentBase64: string,
  contentMediaType: 'image/jpg',
|};
